export const HOSTNAME = window.location.hostname

export const HOSTS = {
  LOCALHOST: 'localhost',
  LOOPBACK: '127.0.0.1',
  LOCAL_TEST: 'web.wisk.test',
  DEV: 'web.wisk.dev',
  FEATURE_1: 'feature1.wisk.dev',
  FEATURE_2: 'feature2.wisk.dev',
  STAGE: 'web.wisk.cool',
  PROD: 'web.wisk.ai'
}

const hostGroups = {
  local: [HOSTS.LOCALHOST, HOSTS.LOOPBACK, HOSTS.LOCAL_TEST],
  dev: [HOSTS.DEV, HOSTS.FEATURE_1, HOSTS.FEATURE_2],
  stage: [HOSTS.STAGE],
  prod: [HOSTS.PROD]
}

export const IS_LAN = HOSTNAME.startsWith('192.168.')
// web.wisk.test: cookie debug mode — HTTPS + cookies, same behaviour as deployed envs
export const IS_COOKIE_DEBUG = HOSTNAME === HOSTS.LOCAL_TEST
export const IS_LOCAL = hostGroups.local.includes(HOSTNAME) || IS_LAN
export const IS_DEV = hostGroups.dev.includes(HOSTNAME)
export const IS_STAGE = hostGroups.stage.includes(HOSTNAME)
export const IS_PROD = hostGroups.prod.includes(HOSTNAME)

export const LOCAL_ENV = {
  PROD: 0,
  STAGE: 1,
  DEV: 2
}
